// Допоміжна функція для доступу до вкладених ключів
function getNested(obj, path) {
  return path
    .split(".")
    .reduce((acc, key) => (acc && acc[key] ? acc[key] : null), obj);
}

export function t(key, data) {
  return getNested(translations, key) || key;
}

export function useTranslation() {
  return { t };
}

const translations = {
  // Redeem: "Redeem",
  // Withdraw: "Withdraw",
  // Open: "Open",
  // Claim: "Claim",
  // "Get Prize": "Get Prize",
  // meta: {
  //   appName: "Funtico",
  //   appDescription:
  //     "Funtico is a new, exciting gaming platform, that takes your favorite genres to unprecedented heights! Your skills aren't just a matter of pride; they unlock incredible prizes and exclusive perks.",
  // },
  homepage: {
    // gamesTitle: "Games",
    // gatewayTICO: "Our token TICO is your gateway to the Funtico ecosystem.",
    // gatewayTICOBtnTitle: "Learn More About TICO",
    // funticoVision: "The Funtico vision",
    // newsUpdates: "News & Updates",
    // partnersTitle: "Partners",
    // visionPrevTitle1: "Fun At The Core",
    // visionPrevTitle2: "Smooth Play, <br /> All The Way! ",
    // visionPrevTitle3: "Play To Win <br /> Meaningful Rewards",
    // visionPrevAlt1:
    //   "At Funtico, we prioritize fun above all else by crafting high-quality games that put the power in the hands of players.",
    // visionPrevAlt2:
    //   "Technology should blend seamlessly into gaming. Funtico's straightforward gameplay is accessible to everyone to ensure optimal user experience.",
    // visionPrevAlt3:
    //   "Fuel your gaming fire with rewards that recognize your journey and achievements.",
    // visionDesc1:
    //   "Funtico offers unparalleled gaming fueled by fun and endless rewards.",
    // visionDesc2:
    //   "With Funtico's new gaming platform, your skills don't just earn  you bragging rights; they score you incredible prizes and exclusive perks. Join high-octane tournaments or face off in gripping one-on-one battles, and experience true ownership of in-game items, skins, packs and more.",
    // joinCommunity: "Join the Funtico <br /> community!",
    // joinCommunityDesc:
    //   "Join our gaming community to experience your favorite games on a whole new level. Are you ready for the challenge?",
    // joinModalCongratilations: "Congratulations",
    // joinModalDesc: "You have successfully subscribed to our newsletter",
    // joinFunticoEmailPlaceholder: "Your E-mail",
    // shopSneakPeekTitle: "Funtico Shop",
    // shopSneakPeekCTA: "Enter now",
  },
  labels: {
    playNow: "Play Now",
    play: "Play",
    close: "Close",
    cancel: "Cancel",
    readMore: "Read More",
    readLess: "Read Less",
    pending: "Pending...",
    searchPlayers: "Search Players...",
    buyNow: "Buy Now",
    buy: "Buy",
    connect: "Connect",
    connected: "Connected",
    disconnect: "Disconnect",
    okay: "Okay",
    save: "Save",
    limited: "Limited",
    rarity: "Rarity",
    season: "Season",
    filter: "Filter",
    filters: "Filters",
    loading: "loading...",
    entries: "Entries:",
    applyFilters: "Apply Filters",
    clearAll: "Clear All",
    clear: "Clear",
    clearChanges: "Clear Changes",
    properties: "Properties",
    stats: "Stats",
    buyer: "Buyer/Receiver",
    seller: "Seller/Provider",
    price: "Price",
    date: "Date",
    obtainedFor: "Obtained For",
    xpAmount: "XP Amount",
    sellerName: "Seller Name",
    selected: "Selected",
    vault: "Vault",
    specialItems: "Special Items",
    trades: "Trades",
    loadMore: "Load More",
    total: "Total",
    players: "Players",
    cpts: "CPTS",
    sneakPeak: "Sneak Peak",
    aboutThisGame: "About this game",
    aboutGame: "About Game",
    howToPlay: "How to play",
    gameItems: "Game Items",
    controlScheme: "Control Scheme",
    gameGuide: "Game Guide",
    tags: "Tags",
    copyLink: "Copy Link",
    languages: "Languages",
    joined: "Joined",
    joinFuntico: "Join Funtico",
    showAll: "Show all",
    owner: "Owner",
    askPrice: "Ask Price",
    clickHere: "Click here",
    trait: "Trait",
    type: "Type",
    description: "Description",
    collection: "Collection",
    listings: "Listings",
    backpack: "My Backpack",
    searchAsset: "Search asset...",
    search: "Search...",
    unlockCondition: "Unlock Condition",
    remove: "Remove",
    showHideDetails: "Show/Hide Card Prop.",
    locked: "Locked",
    claimed: "Claimed",
    claim: "Claim",
    claiming: "Claiming",
    no: "No",
    defaultCursor: "Default Cursor",
    all: "All",
    prefixedNotFound: "{{ prefix }} not found",
    avatars: "Avatars",
    borders: "Borders",
    cursors: "Cursors",
    yourPassword: "Your Password",
    delete: "Delete",
    deleteAccount: "Delete Account",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    confirm: "Confirm",
    set: "Set",
    Verified: "Verified",
    Unverified: "Unverified",
    sentAgain: "Sent again",
    goBack: "Go back",
    nextStep: "Next step",
    ticoAmount: "TICO Amount",
    status: "Status",
    serviceFee: "Service Fee",
    username: "Username",
    email: "Email",
    emailConfirm: "Repeat email",
    leave: "Leave",
    logout: "Log out",
    viewTrailer: "View Trailer",
    playerNotFound: "Player not found",
    signIn: "Sign in",
    signInWithWallet: "Sign in with Wallet",
    signInWith: "Sign in with",
    rememberMe: "Remember me",
    enterPassword: "Enter password",
    sendRequest: "Send request",
    yourMessage: "Your message",
    enterSubject: "Enter your subject",
    back: "Back",
    edit: "Edit",
    or: "OR",
    claimRewards_one: "Claim {{counter}} Reward",
    claimRewards_other: "Claim {{counter}} Rewards",
    outOf: " out of ",
    areSelected_one: "is selected",
    areSelected_other: "are selected",
    setEmail: "set email",
    setEmailSubmit: "Set email",
    settingEmail: "setting email...",
    setEmailSuccess: "Successfully set email",
    pendingEmailConfirmation: " (pending)",
    media: "Media",
    competeToWin: "Compete-2-Win",
    loginToCompete: "Login to compete",
    earned: "TICO Earned",
    spent: "TICO Spent",
    passwordRequired: "Password required",
    kycRequired: "KYC required",
    toPlay: "to play",
  },
  message: {
    cannotDisconnectWithoutEmailPart:
      "Disconnect unavailable because account is created with a wallet",
    somethingWentWrong: "Something went wrong",
    welcomeToFuntico: "Welcome to Funtico",
    serverError: "Server Error",
    tryAgain: "Please try again later",
    cannotChangeDataAfterKycPart1:
      "You cannot edit your personal data because the KYC process has already been completed. Please ",
    cannotChangeDataAfterKycPartSupport: "contact support",
    cannotChangeDataAfterKycPart2: " if you need assistance.",
    thanksForBeingPartOfFunticoFamily:
      "Thanks for being part of the Funtico family!",
    youAlreadyHaveAccount: "You already have a Funtico account",
    gamerOnBoard: "Welcome aboard, gamer!",
    emailPendingForVerificationVerified: "Email Verified!",
    emailPendingForVerificationVerifiedMsg:
      "Your email has been successfully verified.",
    accountDeleted: "Your account has been deleted",
    nowYouCanLogIn: "Now you can log in",
    nftRequestConfirmed: "Your NFT Withdrawal Request Has Been Confirmed!",
    nftRequestConfirmedSubtitle:
      "If any further steps are needed, you will be notified via email within 6 hours. Otherwise, your NFT will be sent to the provided wallet address within 24 hours.",
    withdrawalConfirmed: "Your withdrawal request has been confirmed!",
    withdrawalConfirmedSubtitle:
      "If any further steps are needed, you will be notified via email within 6 hours. Otherwise, your withdrawal will be processed within 48 hours.",
    unknown_confirmation_withdrawal_error:
      "An unknown error occurred while confirming your withdrawal request. Please try again later.",
    invalid_confirmation_code_or_withdrawal_already_approved:
      "Invalid confirmation code or withdrawal already approved",
    socialConnectConnected: "Your {{title}} account is already connected",
    socialConnectSuccess: "Your {{title}} account successfully connected",
    confirmLeaving: "Are you sure you want to leave?",
    forgotPassword: "Forgot your password?",
    passResetSuccess: "Password reset successfully.",
    passResetSuccessDesc:
      "We sent a link to your email to create a new password.",
    messageSent: "Your message has been sent",
    messageSentDesc: "We will contact you as soon as possible",
  },
  layout: {
    header: {
      title: "Funtico",
      wallet: "Wallet",
      register: "Register",
      signIn: "Sign In",
      profile: "Profile",
      kycStatusTooltip: {
        verified: "Your profile is verified",
        notVerified: "Your profile is not verified",
      },
      rankIcon: {
        my: "My Rank Icon",
        next: "Next Rank Icon",
      },
      rankTooltip: {
        current: "Current Rank",
        next: "Next Rank",
        nextRankLv: "Next Lv.",
        needed: "needed",
        level: "Level",
        progress: "Progress",
      },
      balance: "Balance",
      balanceTooltip: {
        title: "Post TGE Balance",
        paragraph1:
          "1. Your Promissory Bonus $TICO tokens (your current Balance before TGE) will be displayed on the platform and credited to the your account after the Token Generation Event (TGE).",
        paragraph2:
          "2. You can use the promissory tokens within the platform to play games, participate in tournaments, and purchase in-game items or NFTs. If the tokens are insufficient for these activities, you can deposit additional funds into your account.",
        paragraph3:
          "3. Players cannot withdraw the promissory tokens for the first 90 days after the TGE. During this period, tokens can only be used within the platform. After 90 days, players can withdraw the remaining tokens or a portion of them, provided some tokens have been used or additional funds have been deposited.",
        paragraph4:
          "4. The tokens are non-transferable within the platform and cannot be transferred to any other player or individual.",
      },
      balanceDetails: {
        title: "Balance Details",
        usable: "Usable",
        withdrawable: "Withdrawable",
        blocked: "Locked",
      },
      deposit: "Buy / Deposit",
    },
    menus: {
      home: "Home",
      tournaments: "Tournaments",
      backpack: "My Backpack",
      marketplace: "Marketplace",
      communityLeaderboard: "Community <br/> Leaderboard",
      joinCommunity: "Join Community",
      shop: "Shop",
      faq: "Need Help?",
      recentlyPlayed: "Recently Played",
      lootPacks: "Loot Packs",
      wheel: "Wheel of Fortune",
      aboutUs: "About Us",
      summonersNft: "Summoners NFT",
      checkLitepaper: "Check Litepaper",
      checkTrailers: "Check Trailers",
      wishlist: "Wishlist Us Now",
      contact: "Contact",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      subtitle: "The Next frontier of Web3 Gaming",
      promotional_campaigns: "Promotional<br/> Campaigns",
      compete2win: "Compete-2-Win",
    },
    form: {
      lastAdded: "Last added",
      removePhoto: "Remove Photo",
      changePhoto: "Click to change Photo",
      chooseAvatar: "Or choose avatar",
      nothingFound: "Nothing to found",
      withdrawMoney: "Withdraw Money",
      amount: "Amount",
      willGet: "You will get",
      withdrawNFT: {
        placeholder: "Your Ethereum Address",
        description: "Note: Address should be ERC-20 compliant.",
        tipTitle: "Enter Your Ethereum Address",
        popupTitle: "Withdraw To Wallet",
        popupSubtitle:
          "In order to withdraw this NFT, please input your wallet address into the text field below.",
        popupInfo:
          "The NFT will be sent directly to the address you provide. If the address is incorrect or inaccessible to you, the NFT will be irretrievably lost and cannot be restored. It is crucial that the provided address is not an exchange address, as this will result in the permanent loss of the NFT.",
        popupBtnConfirm: "Send Withdrawal Request",
        popupBtnRequest: "Withdrawal",
        popupBtnPending: "Pending...",
        successPopupTitle: "Withdrawal Request Submitted",
        successPopupSubtitle:
          "Your request to withdraw your NFT has been submitted successfully. To complete the process, please check your email and click the confirmation button we sent you. <br /> <br /> Important: The withdrawal will only be processed once you confirm the request via email.",
      },
    },
  },
  backpack: {
    pageTitle: "My Backpack",
    tradesHeader1: "Trades",
    tradesSubtitle:
      "From this screen you will manage and review active <br /> trades as well as access past ones.",
    consumablesHeader: "Consumables",
    assets: "Assets",
    specialAssets: "Special Assets",
    specialItems: "Special Items",
    comingSoon: "are coming soon!",
    infinityItemsTitle: "Infinity Items",
    infinityItemsSubtitle:
      "Assets that amass stats and value when used or equipped.",
    shardsTitle: "Shards",
    shardsSubtitle:
      "Enough blueprints of one item will allow forging it and adding it to your Backpack.",
    collectiblesTitle: "Collectibles",
    collectiblesSubtitle:
      "In-Game Boosters, Platform Boosters, Platform Perks, NFTs and more.",
    redeem: "Redeem",
    noFiltersNoMatch: "You do not own any {{term}} at the moment.",
    filtersNoMatch: "No {{term}} are matching your current filtering.",
    shards: "shards",
    consumables: "consumables",
    asset: "assets",
    forge: {
      button: "Forge ({{count}}/100)",
      success: "Item forged successfully",
      error: "Failed to forge item",
    },
    withdraw: {
      button: "Withdraw to Lucky Funatic",
      success: "Item withdrawn to Lucky Funatic successfully",
      error: "Failed to withdraw item to Lucky Funatic",
      lucky_not_connected:
        "Please connect Lucky Funatic account to be able to transfer items",
      withdrawTo: "Withdraw to",
    },
  },
  community: {
    pageTitle: "Community Leaderboard",
    subTitle:
      "Global results for the various communities participating in our tournaments.",
    participatingGames: "Participating Games",
    notice:
      "This username will be secured on the Funtico platform when it launches and will be tied to the email provided in this form.",
    phase: "{{counter}} Phase",
  },
  faq: {
    pageTitle: "Frequently Asked <br /> Questions",
  },
  game: {
    os: {
      windows: "Windows",
      macos: "macOS",
      linux: "StreamOS + Linux",
    },
    requirements: {
      memory: "Memory",
      graphics: "Graphics",
      directx: "DirectX",
      network: "Network",
      storage: "Storage",
      processor: "Processor",
      version: "Version {{version}}",
      broadband: "Broadband Internet connection",
      space: "{{size}} available space",
    },
    languages: {
      chinese: "Simplified Chinese",
      korean: "Korean",
      french: "French",
      german: "German",
      ukrainian: "Ukrainian",
      polish: "Polish",
      english: "English",
    },
    interface: "Interface",
    fullAudio: "Full Audio",
    subtitles: "Subtitles",
    minimumRequirements: "Minimum Requirements",
    packs: "Packs",
    tournaments: "Tournaments",
    allTournaments: "All Tournaments",
  },
  lootpacks: {
    title: "Loot Packs",
    subtitle:
      "Engaging with the Funtico platform and its games will get you exciting rewards in the form of Loot Packs!",
    allPacks: "All Packs",
    packs: "Packs",
    claimRewards_one: "Claim {{counter}} Reward",
    claimRewards_other: "Claim {{counter}} Rewards",
    claimRewardsButton: "Claim",
    outOf: " out of ",
    areSelected: "are selected",
    owned: "Owned",
    rewardedFor: "Rewarded for",
    starterBag: "STARTER BAG",
    starterBagDescription:
      "rewarding early player's progression, discover new assets, collections and features.",
    starterBagInfo:
      "Potential Rewards: XP, Shards, Infinity Items, New Collectibles, Tournament Tickets.",
    giftBox: "GIFT BOX",
    giftBoxDescription:
      "loyalty and engagement, activation campaigns and overall... good behavior. :D",
    giftBoxInfo:
      "Potential Rewards: XP, AP, Shards, Limited Edition Collectibles, Tournament Tickets, Boosters.",
    progressChest: "PROGRESS CHEST",
    progressChestDescription:
      "ranking up through your platform progression by accumulating Experience (XP).",
    progressChestInfo:
      "Potential Rewards: XP, Shards, Limited Edition Collectibles, Profile Customization Assets, Skins.",
    infinityRare: "INFINITY CASE\n (RARE)",
    infinityRareDescription: "opening Capsules and playing Tico Bar.",
    infinityRareInfo: "Potential Rewards: Infinity Items or their Shards.",
    infinityEpic: "INFINITY CASE\n (EPIC)",
    infinityEpicDescription: "opening Capsules and playing Tico Bar.",
    infinityEpicInfo: "Potential Rewards: Infinity Items or their Shards.",
    infinityLegendary: "INFINITY CASE\n (LEGENDARY)",
    infinityLegendaryDescription: "opening Capsules and playing Tico Bar.",
    infinityLegendaryInfo: "Potential Rewards: Infinity Items or their Shards.",
    infinityExotic: "INFINITY CASE\n (EXOTIC)",
    infinityExoticDescription: "opening Capsules and playing Tico Bar.",
    infinityExoticInfo: "Potential Rewards: Infinity Items or their Shards.",
  },
  loyalty: {
    pageTitle: "FunTICO Loyalty Program",
    subtitle:
      "FunTICO's Loyalty Program rewards players for their spending, offering valuable incentives and personalized rewards tailored to their preferences. With exclusive discounts, personalized recommendations, and early access to new releases, the program caters to the target audience's needs, demonstrating FunTICO's commitment to their most loyal customers.",
    howItWorks: "How It Works?",
    stepTitle: "How to Earn Loyalty Points ",
    stepOneSubtitle:
      "You earn Loyalty Points by spending your TICO currency in the ecosystem whether it be through game modes, tournaments, or marketplace purchases. 1 Loyalty Point = 10 USD spent.",
    stepTwoTitle: "How Loyalty Points Work",
    stepTwoSubtitle:
      "As you earn Loyalty Points, you can redeem them for exclusive rewards, such as early access to new games, exclusive tournament tickets, and personalized recommendations. The more Loyalty Points you have, the more rewards you can claim.",
    stepThreeTitle: "How to Redeem Your Rewards",
    stepThreeSubtitle:
      "Once you have enough Loyalty Points, the Claim button will be available for you to redeem and/or choose the rewards that go straight into your account or inventory.",
  },
  luckyFunatic: {
    pageTitle: "Lucky funatic",
    soonSlideOneTitle: "Community Events",
    soonSlideOneSubtitle:
      "As much as we love competition, sometimes team work can make the difference! Engage in different community driven events that unlock unique rewards for all participants.",
    soonSlideTwoTitle: "Saga",
    soonSlideTwoSubtitle:
      "Embark on a grand adventure ripe with rewards and surprises! Get connected more with Funtico's lore, but also with exclusive and limited branded journeys.",
    soonSlideThreeTitle: "Quests",
    soonSlideThreeSubtitle:
      "Play, earn, and then earn some more! Each day new rewarding challenges await you, but be on the lookout, because some might be more elusive than the others.",
    comingSoon: "coming soon...",
    inventory: "INVENTORY",
    inventoryPart1: "As part of Funtico's",
    inventoryPart2:
      ", Lucky Funatic is designed to reward players consistently throughout their journey and progression, and not just on a promise of a future giveaway, based on unclear expectations and rules of engagement.",
    inventoryPart3:
      "By engaging with the current and soon to come features of the game, you can earn Funtico Platform rewards, such as: tickets to big prize tournaments, platform XP, exclusive digital goods, free Spins, Capsules, Shards, NFTs and more!",
    getFunz: "Get 10,000 funz now!",
    evolvedTitle: "TAPPING EVOLVED!",
    evolvedSubtitle:
      "Tap-2-Earn FUNZ, the in-game currency used to upgrade cards, unlock boosters, and progress through the game. With each tap depleting energy, you must strategize to maximize rewards, using temporary and permanent boosters to enhance gameplay.<br /> <br />Tapping also increases the multiplier of your Passive FUNZ (PF) per hour income, but more importantly, it awards you with Jokers, the most valuable commodity of the game!",
    learnMore: "LEARN MORE",
    giveTitle: "JOKERS & giveaways",
    tabAbout: "ABOUT",
    tabRaffle: "RAFFLE",
    tabRaffleLive: "LIVE <br /> NOW!",
    tabEarn: "EARN (TOURNAMENTS)",
    tabEarnSoon: "COMING <br /> SOON!",
    jokerAboutTitle: "Earn 10,000 funz!",
    jokerAboutSubtitle: "Let's see the Joker in action!",
    jokerAboutSubtitle2:
      "Get a head-start, by tapping/clicking your way to 10,000 FUNZ!",
    jokerBtnCollect: "Collect 10,000 Funz",
    jokerNote:
      "NOTE: The 10,000 FUNZ reward can only be claimed by new members!",
    jokerRaffleTitle1: "Be among the first",
    jokerRaffleTitle2: "eligible Funatics!",
    jokerRaffleBecome: "BECOME A FUNATIC!",
    jokerRaffleCurrent: "CURRENT FUNATICS:",
    jokerRaffleEligible: "RAFFLE ELIGIBLE PLAYERS",
    jokerRaffleTimer: " Updating in <span>{{ time }}</span>s",
    jokerRaffleBtnCollect: "COLLECT FUNZ & ENTER RAFFLE!",
    jokerRaffleHowCollect1: "Tap the Joker to earn and collect",
    jokerRaffleHowCollect2: "10,000 FUNZ",
    jokerRaffleHowCollect3: "and enter the",
    jokerRaffleHowCollect4: "10,000 USDT Raffle",
    jokerRaffleEligibleTitle: "AM I ELIGIBLE?",
    jokerRaffleSignInText:
      "To follow your progress on this page, make sure you are",
    jokerRaffleSignedInto: "signed into",
    jokerRaffleQuestComplete1:
      "your Funtico account and that you have completed the ",
    jokerRaffleQuestComplete2: "F-CONNECTED!",
    jokerRaffleQuestComplete3: "quest in Lucky Funatic.",
    jokerRaffleTelegramTasks: "Lucky Funatic / Telegram Tasks",
    jokerRafflePlatformTasks: "Funtico Platform Tasks",
    jokerRaffleInviteFriend: "Invite 1 Friend",
    jokerRaffleReachTaps: "Reach 500 all-time taps",
    jokerRaffleSetUsername: "Set a Telegram Username",
    jokerRaffleLinkAccount: "Link Funtico Account",
    jokerRaffleConnectWallet:
      "Connect Evm compatible Wallet on the Funtico Platform",
    jokerRaffleMessageSuccess: "ABSOLUTELY!",
    jokerRaffleMessageFailed:
      "YOU DID NOT MAKE IT IN TIME... :( <br> GOOD LUCK ON THE NEXT ONE!",
    jokerRaffleRaffleTitle: "RAFFLE RULES",
    jokerRaffleEligibilityInfo:
      'In order to become "Eligible" for this current Raffle, you have to checkmark ALL the 5 tasks above. 3 of them are around easy to achieve Lucky Funatic/Telegram actions and other 2 introduce you to the Funtico Platform (in order for future drops and rewards to be distributed into your account).',
    jokerRaffleMilestoneInfo:
      'Once the 1,000,000 Lucky Funatic players milestone is reached, the Raffle eligibility process will STOP! Only those "Eligible" until then will be part of this Raffle. e.g. - if there are 499,999 "Raffle Eligible Players" when the 1M mark is reached, if another Lucky Funatic becomes Eligible, the counter will not change to 500,000, even if the "Current Funatics" counter will continue to grow over 1M.',
    jokerRaffleRewardsTitle: "Rewards Structure:",
    jokerRaffleRewardsFirst: "1st Raffle: 500 USDT, for one lucky winner",
    jokerRaffleRewardsSecond: "2nd Raffle: 250 USDT, for one luckywinner",
    jokerRaffleRewardsThird: "3rd Raffle: 100 USDT, for one lucky winner",
    jokerRaffleRewardsFourth:
      "4th Raffle: 100 USDT, for two lucky winners (50 USDT/each)",
    jokerRaffleRewardsFifth:
      "5th Raffle: 50 USDT, for two lucky winners (25 USDT/each)",
    jokerRaffleRewardsSixth:
      "the 6th Raffle will reward 9,000 USDT to 450 winners (20 USDT/each)",
    jokerRaffleStructureTitle: "Raffle Structure:",
    jokerRaffleStructureTiming:
      "The Raffle will take place within 7 days (TBA on Funtico social channels) after the 1M milestone has been reached, after internal checks will be conducted against suspicious behavior. It will be designed as 6 consecutive Raffles, one after another.",
    jokerRaffleStructureTelegramPool:
      "All the Telegram usernames of the eligible users will be added into the pool and the Raffles will be livestreamed via our Discord channel",
    jokerRaffleStructureChannel: "channel",
    jokerRaffleStructureWinnerRemoval:
      "After each round, the winner(s) will be removed from the remaining pool. e.g. - after the 1st Raffle, the winner will not be included in the 2nd Raffle; the 2nd Raffle winner, will not be included in the 3rd Raffle and so on...",
    jokerRaffleStructureLastRaffle:
      "In the 6th Raffle we will extract, in one go, 450 winners.",
    jokerRaffleStructureDistribution:
      "All of the rewards will be distributed, within 48h, after the 6 Raffles have been conducted, directly in the ERC-20 compatible wallet, that each participant have connected to the Funtico Platform.",
    jokerRaffleGoodLuck: "GL & HF everyone!",
    jokerWorldPageTitle: "ENTER A MADDENING WORLD!",
    jokerWorldPageDescription1:
      "Funtico is shaking up the gaming world with the launch of <span>Lucky Funatic</span>, a hyper-casual, Tap-2-Earn clicker game within <span>Funtico's Telegram Entertainment Hub</span>.",
    jokerWorldPageDescription2:
      "<span>Lucky Funatic</span> takes the Tap-2-Earn concept to unprecedented levels, combining innovative gameplay with a unique feature set and multiple rewards!",
  },
  market: {
    pageTitle: "Marketplace (Sneak peek)",
    assetsNotFound: "Assets not found",
    tradesHeader: "In this screen you will be able to see assets in your",
    tradesHeaderBackpack: "Backpack",
    tradesHeaderMarketable: "that are marketable.",
    sneakPeak: "Marketplace (Sneak Peak)",
    goTo: "Go to Marketplace",
  },
  policy: {
    pageTitle: "Privacy Policy",
    introText:
      "Funtico values user privacy and is committed to protecting personal information. The privacy policy outlines how player data is collected, used, and safeguarded.",
    informationTitle: "1. Information Collection",
    informationIntro:
      "Funtico collects certain information during the registration process, including but not limited to:",
    informationDetails:
      "Name, email address, age, and other optional profile details.",
    informationTechnical:
      "Technical information such as IP address, device information, and cookies.",
    useTitle: "2. Use of Information",
    useIntro: "Funtico may use the information:",
    useRegistration:
      "Collected information is used to facilitate early registration, provide in-game benefits, and enhance the gaming experience.",
    useAnalytics:
      "Funtico may use aggregated and anonymized data for analytics, research, and marketing purposes.",
    useService: "To provide and maintain the Service",
    useNotify: "To notify you about changes to our Service",
    useFeatures:
      "To allow you to participate in interactive features of our Service",
    useSupport: "To provide customer care and support",
    useMonitor: "To monitor the usage of the Service",
    useTechnical: "To detect, prevent and address technical issues",
    securityTitle: "3. Data Security",
    securityText:
      "Funtico employs industry-standard security measures to protect player data from unauthorized access, alteration, disclosure, or destruction.",
    disclosureTitle: "4. Third-Party Disclosure",
    disclosureText:
      "Player information may be shared with trusted third-party service providers for the purpose of improving services or as required by law.",
    rightsTitle: "5. User Rights",
    rightsAccess:
      "Players have the right to access, modify, or delete their personal information stored by Funtico.",
    rightsOptOut:
      "Opt-out options for marketing communications should be available and easily accessible.",
    cookieTitle: "6. Cookie Policy",
    cookieText:
      "Funtico utilizes cookies and similar tracking technologies to enhance user experience.",
    childrenTitle: "7. Children's Privacy",
    childrenService:
      'Our Service does not address anyone under the age of 18 ("Children").',
    childrenCollection:
      "We do not knowingly collect personally identifiable information from anyone under the age of 18.",
    changesTitle: "8. Changes to the Privacy Policy",
    changesText:
      "Funtico reserves the right to update or modify the privacy policy from time to time.",
  },
  profile: {
    menuRanks: "Rank & Progress",
    menuAppearance: "Customize Appearance",
    menuMyReferrals: "My Referrals",
    menuHistory: "Transaction History",
    menuSettings: "Account Settings",
    menuVerification: "KYC Verification",
    menuConnectedAccounts: "Connected Accounts",
    menuPromotionalCampaigns: "Promotional Campaigns",
    pageTitleMyReferrals: "MY REFERRALS",
    referrals: {
      statsTicoRewards: "Total $TICO Rewards",
      statsEligibleReferrals: "Total Eligible Referrals",
      statsPendingReferrals: "Total Pending Referrals*",
      multiplierTicketAlt: "Multiplier Ticket",
      linkSectionTitle: "My Referral Link",
      linkDescription:
        "Use the link above to send to your friends and communities.",
      inviteSectionTitle: "Invite Friends & Earn Together!",
      inviteDescription1:
        "What is better than playing with friends? Winning together!",
      inviteDescription2:
        "Every time a new player registers via your referral link you get rewarded $TICO tokens and both of you earn Multiplier Tickets, if the following are met:",
      condition1: "They deposit at least 750 $TICO;",
      condition2: "They use/spend at least 500 $TICO within the platform.",
      rewardsClarification:
        "The rewards in both $TICO and Multiplier Tickets are allocated only <strong class='fixel_16_bl'>once</strong>, per referral, after the both conditions above are met.",
      rewardsTableTitle: "How Many $TICO & Multiplier Tickets I Get Rewarded?",
      tierFirst10: "First 10 Referrals",
      tier11to25: "Referrals 11-25",
      tier26to50: "Referrals 26-50",
      tier50plus: "Referrals 50+",
      tableForEach: "for each",
      firstDepositBonus:
        "Each of your referrals will get 1x <0></0> and 1x <1></1> upon completing their first ever deposit.",
      note1:
        "Note: the $TICO values above are the maximum ones envisaged, but they are subject to change and will change/adjust lower periodically based on $TICO's price and its marketcap. That is done to ensure fairness across the board, where users who provide referrals earlier are not at a disadvantage. For example, if the price of $TICO increases x10, the reward will become $10 in $TICO instead of $100 in $TICO at the moment of the deposit, in order for you and your friends to have the same value of reward.",
      note2Pending:
        "*Pending referrals are players that might have not done one of the following: verify their email, deposit the minimum $TICO needed, use/spend the minimum 500 $TICO required.",
      copiedFeedback: "Copied!",
      eachRefGet: "Each of your referrals will get",
      and: "and",
      ifDeposit:
        "ONLY upon completing their first ever $TICO deposit and after using/spending 500 $TICO.",
      limitedOfferHeader: "Limited Offer!",
      limitedOffer:
        "Your friends might be in for a surprise! The first 2,000 players that registered through the referral links, will also receive 500 $TICO Bonus, one time, after depositing at least 750 $TICO and using/spending at least 500 $TICO!",
      limitedOfferDescription:
        "The 500 $TICO Bonus your referral(s) will receive, will be locked on the platform (not withdrawable), but it can be used and the potential earnings withdrawn.",
    },
    settingsSubtitle:
      "Effortlessly manage all aspects of your account, from security measures to communication preferences, in one convenient location.",
    rank: "Rank",
    nextRank: "Next Rank",
    seeAllRanks: "See all ranks",
    ranksSubtitle1:
      "Welcome to your Progress Dashboard, where you can track your rank and claim your hard-earned rewards!",
    seasonalProgress: "Seasonal Progress",
    historyTabTico: "TICO Earned & Spent",
    historyTicoTabDeposits: "TICO Deposits",
    historyTicoTabWithdrawals: "TICO Withdrawals",
    historyTabWithdrawals: "NFT Deposits & Withdrawals",
    historyDescription: "No deposits or withdrawals available yet.",
    connectedAccountsDescription:
      "It is important to stay connected so we can reach out or distribute your rewards in a timely and efficient manner. Also, extra XP never hurt anyone 😄",
    appearanceSetSuccess: "Profile appearance updated successfully",
    appearancePreview: "Preview",
    appearanceOnlyDesktop: "Only on desktop",
    deletePageTitle: "Delete My Funtico Account",
    deletePopupTitle: "Are you sure you want to delete your account?",
    deletePopupSubtitle:
      "Deleting your account means losing access to all your progress on the Funtico platform, including your active balance.",
    deleteSadMessage1:
      "We're sad to see you go. If you wish to terminate your account you can do so here.",
    deleteSadMessage2:
      "Do note that terminating your account will permanently delete all your data and it is an action that cannot be undone.",
    loyaltyProgramUpdates: "Loyalty Program Updates",
    personalizedSpecialOffers: "Personalized Special Offers",
    dailyBonus: "Daily Bonus",
    weeklyUpdates: "Weekly Updates",
    tournamentWinnings: "Tournament Winnings",
    newsletter: "Marketing Communications",
    newsletterSubtitle:
      "Get the latest news, product highlights, and special promotions directly from&nbsp;us.",
    allowMarketingCommunication: "Receive Marketing Messages",
    languageChange: "Change Preferred Language",
    passwordChange: "Change Password",
    passwordForgot: "I forgot my password",
    passwordRequest: "Send Password Reset Email",
    passwordChangedSuccess: "Your password has been successfully changed",
    passwordChangedSuccessSubtitle:
      "Use a new password to log in to the account",
    passwordRequestSent: "A password Reset request Has been sent to",
    allPlatformRanks: "Platform Ranks",
    tfaTitle: "Two-Factor Authentication",
    tfaQrScan:
      "Scan QR code using the authenticator app. Or enter the key manually",
    tfaCode: "Enter code",
    tfaCodeQuestion: "You don't have code?",
    tfaEnterCode:
      "Enter the 6-digit authentication code from your authenticator app",
    tfaRecommended: "Apps we recommend",
    tfaDesc1: "Protect your account with an additional layer of security using",
    tfaDesc2: "Your account is currently protected with the additional",
    tfaDesc3: "layer of security.",
    kycSecurity: "Security",
    kycLi1: "Smooth & Fast Withdrawal Process",
    kycLi2: "Extra Customizable Assets",
    kycLi3: "Extra ~50% Platform XP Gain",
    kycLi4: "Weekly Gift Box Drops",
    kycCheckingStatus: "Checking verification status...",
    kycVerifyAccount: "Verify Account",
    kycVerifiedAccount: "Verified Account",
    kycIsVerified: "Your account is verified!",
    kycNotVerifiedMsg:
      "In order to be able to withdraw your potential rewards from the $100,000 Tournaments, you need to have your account verified, by successfully going through a simple KYC process. A Verified Account will also unlock the following perks:",
    kycPopupTitle: "Verify your Identity",
    kycPopupCode: "You don't have code?",
    kycPopupEmailMessage: "Don't you have a message in your email?",
    kycPopupCta: "Write to us",
    kycSendAgain: "Send again",
    stayConnected: "Stay Connected",
    stayConnectedSub:
      "Manage your connection to your wallet and social accounts.",
    authStep1:
      "Install an authenticator app like Google Authenticator or Authy on your mobile device or computer.",
    authStep2:
      'Click "Add account" and scan the QR code or add it manually with the secret key.',
    authStep3: "Type in the code from your MFA app on the FunTICO platform.",
    noTicoTransactions: "Your currently have no $TICO transactions.",
    registerFirstName: "Your first Name",
    registerFirstNameLabel: "First name",
    registerLastName: "Your last Name",
    registerLastNameLabel: "Last name",
    registerBirth: "Your Date of birth",
    registerBirthLabel: "Date of birth",
    registerCountry: "Choose your country",
    registerCountryLabel: "Country",
    userUpdateSuccess: "Personal information has been updated successfully",
    personalInfoTitle: "Personal Info",
    personalAccountInfoTitle: "Account Info",
    noTransactions:
      "Your currently have no NFT Deposits & Withdrawals transactions.",
    tfa: {
      googleAuth: "Google Authenticator",
      authy: "Authy",
      microsoftAuth: "Microsoft Authenticator",
    },
    connectedIssue: "Having issues with connecting Telegram?",
    experienceHistory: "Experience History",
    experienceHistoryEmpty: "Your current Experience history is empty.",
    experienceHistoryNoMore: "No more items to load",
    experienceHistoryLoadingMore: "Loading more...",
    allRanksXpNeeded: "XP Needed",
    allRanksSurpassed: "surpassed",
    allRanksAchieved: "achieved",
    allRanksXpEarned: "Earned at {{ xpValue }} XP",
    transactionHistory: {
      deposit_statuses: {
        created: "Created",
        awaiting_chain_confirmations: "Awaiting Blockchain Confirmations",
        received: "Received",
        kyt: "Compliance Screening",
        full_kyc_required: "Full KYC Required",
        to_be_reviewed: "Pending Review",
        mlt_flagged: "Flagged for Risk",
        frozen: "Frozen",
        sent_back: "Returned",
        credited: "Credited",
      },
      withdrawal_statuses: {
        created: "Created",
        "2fa": "Awaiting Email Confirmation",
        confirmed_by_user: "Confirmed by User",
        kyt: "Compliance Screening",
        to_be_reviewed: "Pending Review",
        approved: "Approved",
        rejected: "Rejected",
        processing: "Processing",
        withdrawn: "Withdrawn",
        canceled: "Canceled",
        expired: "Expired",
      },
    },
  },
  404: {
    titleDefault: "Page",
    titlePart: "{{pageName}} not found",
    404: "404",
    back: "Bring me back",
  },
  counters: {
    0: "Zero",
    1: "One",
    2: "Two",
    3: "Three",
    4: "Four",
    5: "Five",
    6: "Six",
    7: "Seven",
    8: "Eight",
    9: "Nine",
  },
  compete2win: {
    pageTitle: "Compete-2-Win",
    tournaments: "Tournaments",
    rooms: "Rooms",
  },
  tournaments: {
    pageTitle: "Tournaments",
    featured: "Featured",
    ongoing: "Ongoing",
    upcoming: "Upcoming",
    pending: "Pending",
    ended: "Ended",
    allPrizes: "All Prizes",
    externalNFTs: "External NFTs",
    communityNotFound: "Community not found",
    funticoRewards: "Funtico Rewards",
    searchTournaments: "Search tournaments...",
    prize: "Prize",
    entryType: "Entry Type",
    maxPlayers: "Max Players",
    loginToCompete: "Login to compete",
    gpp: "GPP",
    enterForFree: "Enter For Free",
    enterWithCode: "Enter With Code",
    firstPlace: "1<sup>st</sup> PLACE",
    secondPlace: "2<sup>nd</sup> PLACE",
    thirdPlace: "3<sup>rd</sup> PLACE",
    prizePool: "Prize Pool",
    tba: "TBA",
    live: "LIVE",
    prizeAlt: "Prize",
    detailAlt: "Detail",
    noRewards: "No Rewards",
    seeAllPrizes: "See All Prizes",
    prizePoolDistribution: "Prize Pool <br/>Distribution",
    singleEntry: "Single",
    reEntry: "Multiple",
    uncapped: "Uncapped",
    checkResults: "Check Results",
    leaderboard: "Leaderboard",
    downloadApk: "Download APK",
    enterFor: "Enter For",
    semiFinal: "Semi Final",
    theSummoners: "The Summoners",
    final: "Final",
    boardEmpty:
      'The <span class="color-white">Leaderboard</span> will be populated once the first relevant result has been registered.',
    rewardedPlaces: "Rewarded places",
    locked: "The Leaderboard is temporarily locked!",
    lockedSubtitle:
      "We've detected some irregularities and, to maintain the integrity of the results, <br />we are performing internal tests with our fraud detection tools. <br />Please stay tuned for further updates.",
    noTournamentsFound: "No tournaments found",
    endsIn: "Ends in",
    startsIn: "Starts in",
    timeSinceEnded: "Time since ended",
    details: "Details",
    your_history: "My History",
    tournamentName: "Tournament Name",
    status: "Status",
    myPlace: "My Place",
    failedToFetchPrizes: "Failed to fetch prizes",
    failedToFetchPrizesDesc: "Please try again later.",
  },
  rooms: {
    room: "Room",
    roomName: "Room Name",
    pageTitle: "Rooms",
    prizePool: "Prize Pool",
    enterFor: "Enter For",
    tryAgain: "Try Again For",
    free: "FREE",
    prizeMultiplier: "Prize multiplier",
    firstPrizeMultiplier: "1<sup>st</sup> prize multiplier",
    roomType: "Entry Type",
    enter: "Enter",
    details: "Details",
    checkResults: "Check Results",
    status: "Status",
    active: "Open",
    inactive: "Closed",
    top: "Top",
    rewarded: "Rewarded",
    leaderboard_empty:
      'The <span class="color-white">Leaderboard</span> will be populated once the first relevant result has been registered.',
    noRoomsFound: "No rooms found",
    ongoing: "Ongoing",
    history: "My History",
    loadMore: "Load more",
    noMoreRooms: "No more rooms",
    max: "Max",
    champion: "Champion",
    challenger: "Challenger",
    contender: "Contender",
    playerNotFound: "Player not found",
    prizes: {
      notYetDistributed: "Not yet distributed",
      awaitingResults: "Awaiting results",
    },
    player: {
      playerNeeded: "Player Needed",
      TBD: "TBD",
    },
    score: {
      titleNotScored: "Player was not scored, and will not be awarded",
      disqualified: "Disqualified",
    },
  },
  promotions: {
    title: "Our promotions",
    createAccount: "Create An Account",
    createAccountTitle: "Create An Account",
    createAccountSubtitle:
      "We believe that work is at its best when our people can be their authentic selves. That's why we're committed to fostering an inclusive workplace, where our employees can",
    loadUpTitle: "Load Up",
    loadUpSubtitle:
      "We believe that work is at its best when our people can be their authentic selves. That's why we're committed to fostering an inclusive workplace, where our employees can",
    playEarnTitle: "Play & Earn",
    playEarnSubtitle:
      "We believe that work is at its best when our people can be their authentic selves. That's why we're committed to fostering an inclusive workplace, where our employees can",
    exclusiveGiftBoxBonus:
      "Register and verify your account before TGE and get an exclusive <span class='fixel_16_sbl'>Gift Box Bonus</span>, containing a bundle of 10 different tickets to tournaments and events with <b>$100,000+</b> in prize pools!",
    exclusiveGiftBoxBonusLinkText:
      "Learn more about this limited time campaign!",
    exclusiveGiftBoxBonusLink: "/",
  },
  promotionCode: {
    title: "Time for rewards!",
    modalDescription:
      "Make a deposit of $5 worth of $TICO and claim your reward.",
    subtitle:
      "Make a deposit of $5 worth of $TICO and claim the following rewards",
    checkCampaigns: "Check active campaigns",
    checkRequirements: "Check requirements",
    loginToClaim:
      "Log in and access Promotional Campaigns to claim your Bonus.",
    requirements: "Requirements",
    claimRewards: "Claim Rewards",
    howItWorks: "How it works",
    stepOneHowItWorks: "Make a deposit.",
    stepTwoHowItWorks:
      "After making your deposit, the rewards will be automatically assigned to your account.",
    noCampaign:
      "No active offers right now. Keep an eye out for future promotions where you can earn rewards!",
    alreadyJoined: "It seems you've already claimed your Starter Pack rewards",
    join: "Join",
    joinSuccessTitle: "You have successfully joined the campaign!",
    joinSuccessSubtitle: "You can now claim your rewards.",
    yourCampaigns: "Your Campaigns",
    readyToJoin: "Ready To Join",
    joining: "Joining...",
  },
  shop: {
    pageTitle: "Shop",
    nothingForSale: "Nothing for sale yet",
    fetchError:
      "Sorry. We could not fetch items right now. Please try again later.",
    filter: "Filter",
    cancel: "Cancel",
    applyFilters: "Apply Filters",
    limited: " (Limited)",
    askPrice: "Price",
    buyNow: "Buy now",
    moreInfo: "More info",
    confirmPurchase: "Confirm Your Purchase",
    aboutToPurchase: "You are about to purchase {{name}}.",
    proceedQuestion: "Would you like to proceed?",
    totalCost: "Total Cost",
    confirm: "Confirm",
    congratulations: "Congratulations!",
    acquiredItem: "You've acquired {{name}}.",
    seeInInventory: "See in Inventory",
    somethingWentWrong: "Something went wrong",
    tryAgainLater: "Please try again later.",
    okay: "Okay",
    filterIcon: "{{name}} icon",
    removeFilter: "Remove {{filter}}",
    clearAll: "Clear all",
    filters: "Filters",
  },
  wheel: {
    pageTitle: "Wheel of fortune",
    title: "WHEEL OF FORTUNE",
    subtitle:
      "The perfect place to get even more enjoyment out of the Funtico platform. Make sure to visit and claim the Daily Bonus every day for platform XP, free Spins and extra Rewards.",
    spinsAvailable: "SPINS AVAILABLE:",
    spinButton: "Spin",
    streak: "STREAK: {{count}}",
    streakMessage: {
      startDay: {
        beforeSpin:
          'Claim your <span class="fixel_16_bl">Daily Bonus</span> for {{count}} consecutive days and we\'ll reward you with {{spins}} extra <span class="fixel_16_bl">Spins!</span>',
        afterSpin:
          'Enjoy your reward! {{spins}} free <span class="fixel_16_bl">Spins</span> have been added to your balance! Can you do it again? 💪',
      },
      middleDay: {
        beforeSpin:
          'Claim the <span class="fixel_16_bl">Daily Bonus</span> today to get your streak to the next level! Reach <span class="fixel_16_bl">Streak {{count}}</span> to receive {{spins}} extra <span class="fixel_16_bl">Spins!</span>',
        afterSpin:
          'Congrats! You got your streak going! Make sure to return tomorrow! Reach <span class="fixel_16_bl">Streak {{count}}</span> to receive {{spins}} extra <span class="fixel_16_bl">Spins!</span>',
      },
      streakDay: {
        beforeSpin:
          'Claim your <span class="fixel_16_bl">Daily Bonus</span> today to reach <span class="fixel_16_bl">Streak {{count}}</span> and be rewarded with {{spins}} extra free <span class="fixel_16_bl">Spins!</span>',
        afterSpin:
          'You reached a new streak level! Come back tomorrow once more to be rewarded {{count}} extra free <span class="fixel_16_bl">Spins</span> for <span class="fixel_16_bl">Streak {{count}}</span>!',
      },
    },
    dailyBonusNote:
      '<span class="fixel_16_bl">Note</span>: The <span class="fixel_16_bl">Daily Bonus</span> resets at midnight (00:00 am) UTC time.',
    claimDailyBonus: "Claim Daily Bonus",
    youGet: "You get",
    prizes: {
      experiencePoints: "EXPERIENCE POINTS",
      unlucky: "UNLUCKY",
      comingSoon: "Coming Soon",
      youLose: "Lol, you lose",
      youWon: "You won",
      prizeImage: "Prize image: {{name}}",
    },
  },
  terms: {
    pageTitle: "Terms and Conditions",
    title: "Terms and Conditions",
    linkText: "Link to Terms and Conditions PDF",
  },
  login: {
    signUpNow: "Sign up now",
  },
  registration: {
    forgotPassword: "Forgot password",
    resetPassword:
      "Enter your email and we will send you a link to reset your password",
    resetNoAccess: "No access to e-mail?",
    resetCreateNewAccount: "Create new account",
    resetCreateNewPass: "Create new password",
    resetCreateNewPassSuccess:
      "Your password has been successfully reset. Create and enter a new password",
    resetChatWithUs: "Or chat with us in",
    resetDiscord: "Discord community",
    alreadyHaveAccount: "Already Have An Account?",
    signInNow: "Sign in now",
    notMember: "Not a member?",
    errors: {
      passwordMin: "Password must be at least 8 characters long",
      passwordRequirements:
        "Password must contain at least one uppercase letter, lowercase letter, number and special character.",
      passwordMatch: "The passwords must match",
      emailInvalid: "Please enter a valid email address",
      emailExists: "Email address already in use",
      emailMatch: "The emails must match",
      usernameLength: "Username must be between 3 and 15 characters long",
      usernameTaken: "This username is already taken",
      toManyAttempts: "Too many attempts, please try again later",
    },
    labels: {
      username: {
        placeholder: "Username",
        description:
          "This username will be secured on the Funtico platform when it launches and will be tied to the email provided in this form.",
        tip: "Your chosen username must be between 3 and 15 characters long and may include only underscores and numbers",
      },
      email: {
        placeholder: "Enter your e-mail",
        title: "E-mail",
      },
      password: {
        placeholder: "Enter your password",
        title: "Password",
        tip: "Your chosen password must be at least 8 characters long and it should include an Upper Case, a lower case, at least 1 number and a special character (!, @, #, etc.)",
      },
      passwordConfirm: {
        placeholder: "Repeat your password",
        title: "Repeat password",
      },
      country: {
        placeholder: "Enter your country",
        title: "Country",
      },
      consent: {
        title:
          'By creating an account, I agree to the <a title="Terms & Conditions" target="_blank" href="/terms-and-conditions.pdf">Terms & Conditions</a> and acknowledge the <a title="Privacy Policy" target="_blank" href="/privacy-policy">Privacy Policy</a>; I confirm that I am 18 years of age or older, and understand that I may receive updates from Funtico.',
      },
      // age: {
      //   title: "I am 18 years or older",
      // },
      // agree: {
      //   title: "I agree to the Terms and Conditions",
      //   label: "I agree to the",
      //   labelAnd: "and",
      // },
      // newsletter: {
      //   title:
      //     "Receive updates about Funtico games, tournaments, and promotions",
      // },
    },
    success: {
      title: "VERIFICATION REQUIRED",
      subtitle: "A verification link has been sent to your email account.",
      close: "Okay",
    },
    tabs: {
      password: "Email & Password",
      wallet: "Crypto Wallet",
    },
  },
  rarity: {
    common: "Common",
    uncommon: "Uncommon",
    rare: "Rare",
    epic: "Epic",
    legendary: "Legendary",
    exotic: "Exotic",
  },
  filters: {
    filterBy: "Filter by",
    categories: {
      game: "Game",
      rarity: "Rarity",
      trait: "Trait",
      type: "Type",
      collection: "Collection",
      platformSeason: "Season",
      status: "Status",
      price: "Price",
      categories: "Categories",
    },
    games: {
      sharkFinFrenzy: "Shark Fin Frenzy",
      formulaFuntico: "Formula Funtico",
      heroesOfTheCitadel: "Heroes of the Citadel",
      solitaireSlam: "Solitaire Slam",
      dropDudes: "Drop Dudes",
      bingoRampage: "Bingo Rampage",
    },
    price: {
      minPrice: "Min Price",
      maxPrice: "Max Price",
      to: "To",
    },
    rarity: {
      common: "Common",
      uncommon: "Uncommon",
      rare: "Rare",
      epic: "Epic",
      legendary: "Legendary",
      exotic: "Exotic",
    },
    traits: {
      infinityItems: "Infinity Items",
      shards: "Shards",
      collectible: "Collectible",
      inGameBooster: "In-Game Booster",
      platformBooster: "Platform Booster",
      platformPerk: "Platform Perk",
      nft: "NFT",
    },
    types: {
      equippable: "Equippable",
      weapon: "Weapon",
      skin: "Skin",
      armor: "Armor",
      playable: "Playable",
      hero: "Hero",
      driver: "Driver",
      vehicle: "Vehicle",
      shark: "Shark",
      consumable: "Consumable",
      lootbox: "Lootbox",
      capsule: "Capsule",
      scratchCard: "Scratch Card",
    },
    collections: {
      pioneers: "Pioneers",
      summoners: "Summoners",
      earlyAdopters: "Early Adopters",
    },
    seasons: {
      summers: "Summers",
      season1: "Season 1",
    },
    status: {
      on_sale: "On Sale",
      sellable: "Sellable",
      cannotBeSold: "Cannot Be Sold",
      mintable: "Mintable",
      forgeable: "Forgeable",
      cannotBeForgedYet: "Cannot Be Forged Yet",
    },
    labels: {
      owner: "Owner",
      ask_price: "Ask Price",
      rarity: "Rarity",
      trait: "Trait",
      type: "Type",
      collection: "Collection",
      season: "Season",
    },
    byDateObtained: "By Date Obtained",
    newToOld: "New to Old",
    oldToNew: "Old to New",
    byName: "By Name",
    aToZ: "A to Z",
    zToA: "Z to A",
    byType: "By Type",
    cancel: "Cancel",
  },
  wallet: {
    title: "Buy / Deposit",
    buyTico: "Buy $TICO",
    depositTico: "Deposit $TICO",
    withdrawTico: "Withdraw $TICO",
    tabInfo: "Info",
    info: {
      placeholder: "Someday there will be some text here",
    },
    buySection: {
      labels: {
        fiatPurchaseNotSupportedCountry:
          "Buying with FIAT currencies is currently not supported in your country",
        fiatPurchaseNotSupportedEmail:
          "You need to provide an e-mail to buy $TICO with FIAT currency",
      },
      methodSelection: {
        chooseMethod: "Choose how you would like to buy $TICO:",
        fiatOption: "Buy $TICO <br /> with FIAT (credit card)",
        cryptoOption: "Buy $TICO <br /> with CRYPTO",
        exchangeOption: "Buy $TICO on <br /> an exchange",
      },
      exchange: {
        instructions:
          "To deposit $TICO via an exchange platform, follow the instructions below:",
        qrCode: "Wallet QR Code",
        steps: {
          1: "Go to one of these exchanges:",
          2: "Buy $TICO on selected exchange",
          3: "From selected exchange, go to the crypto withdrawal page",
          4: "Select $TICO as currency to be withdrawn",
          5: "Select Avalance for the network",
          6: "Copy and paste the following wallet address into the designated field:",
          7: "After checking that everything is in order, proceed with the deposit",
        },
      },
      fiat: {
        amountPlaceholder: "Enter amount",
        amountTip: "Enter the amount you want to buy",
        bonusPlaceholder: "Enter bonus code (optional)",
        bonusTip: "Enter your bonus code if you have one",
        toReceive: "...to receive",
        tryAnotherAmount: "Please try another amount",
        addAmount: "Add {{amount}}",
        subtractAmount: "Subtract {{amount}}",
      },
      crypto: {
        amountPlaceholder: "Enter amount",
        amountTip: "Enter the amount you want to buy",
        bonusPlaceholder: "Enter bonus code",
        bonusOptional: "Bonus Code (Optional)",
        bonusTip: "Enter your bonus code if you have one",
        iWantToPay: "I want to pay",
        alsoListedOn: "Also listed on:",
        tryAnotherAmount: "Please try another amount",
        transaction: {
          purchaseCompleted: "Purchase Completed",
          transferReceived:
            "Your transfer has been received! <br> <br> You will be notified as soon as the transaction has been successfully confirmed!",
          letsPlay: "Let's Play!",
          buyTico: "Buy $TICO",
          finalizePayment: "Finalize Your Payment",
          orderWaiting: "Your Order no. {{uuid}} is waiting for payment.",
          amountToSend: "Amount to be sent",
          toAddress: "to this Address",
          memo: "Memo",
          toReceive: "to receive",
          connectWallet: "Connect Wallet To Pay",
          qrCode: "QR Code",
          scanQrCode: "Scan this QR code with <br /> your crypto wallet app",
          waitingForTransaction: "Waiting for your transaction...",
          safeToClose:
            "Once the funds are sent, you <br /> can safely close this window.",
        },
      },
      provider: {
        youPay: "You Pay",
        includingFees: "Including fees",
        exchangeRate: "Exchange Rate",
        youGet: "You Get",
        refreshMessage: "Exchange rate will refresh again in",
      },
    },
    withdraw: {
      successful: "Withdrawal Request Successful!",
      confirmRequest: "To confirm your withdrawal request of",
      confirmRequestNo2FA:
        "Your withdrawal request will be processed within 48 hours.",
      checkEmail: "please check the email sent on {{email}}",
      title: "Withdraw $TICO",
      withdrawingTo: "Withdrawing to",
      amountToWithdraw: "Amount to withdraw",
      serviceFee: "Service fee",
      availableToWithdraw: "Available to withdraw",
      amountUGetWithdraw: "Amount you get",
      balanceAfterWithdrawal: "Withdrawable balance after withdrawal",
      confirmWithdrawal: "Confirm Withdrawal",
      flow: {
        enterAmount: "Enter amount",
        withdrawTip: "Enter the amount you want to withdraw",
        enterWalletAddress: "Enter wallet address",
        addressNote: "Please double-check the address before confirming",
        selectChain: "Select Network",
        withdraw: "Withdraw",
        kycRequirement:
          "To withdraw funds, you need to complete the verification process.",
        verifiedAccount: "Get Verified Account",
        readTerms: "Please read our terms and conditions before proceeding.",
        withdrawAmountError: "Amount is more than available to withdraw",
      },
      noEmailTitle: "Email Required to Withdraw",
      noEmailMessage:
        "To process your withdrawal, we need a valid email address on your account. Please add your email in your profile settings. This is required so we can contact you if there are any issues with your withdrawal.",
      goToProfileSettings: "Go to Profile Settings",
    },
    balance: {
      current: "Current balance",
      locked: "Locked balance",
      availableToWithdraw: "Available to withdraw",
      lockedTooltip:
        "Balance earned from activities and events - usable in Tournaments, Rooms, or Shop. Any winnings you earn with it are fully withdrawable!",
    },
    kyc: {
      depositRequirement:
        "To deposit funds, you need to complete the verification process.",
      completeKyc: "Complete Verification",
    },
    currency: {
      selectCurrency: "in the following currency",
    },
    deposit: {
      instructions: "Follow these steps to deposit your funds:",
      steps: {
        1: "Select the network you want to use for the deposit",
        2: "Copy the deposit address",
        3: "Send your funds ($TICO only!) to this address",
        4: "Wait for the transaction to be confirmed",
        5: "Your funds will be credited to your account",
        6: "You can now use your funds",
      },
      selectChain: "Select Network",
    },
    connect: "Connect Wallet",
    authenticate: "Sign with Wallet",
    authenticating: "Signing...",
    errors: {
      failed: "Failed to authenticate",
      authFailed: "Authentication failed",
    },
  },
  auth: {
    unauthorized: "You are not authorized",
    pleaseLoginOrRegister: "Please login or register and try again",
  },
  cards: {
    pageTitle: "Scratch Cards",
    blackGold: "Black Gold card",
    silver: "Silver card",
    gold: "Gold card",
    balance: "Balance",
    choseGame: "Choose game",
    about: "About scratch Cards",
    works: "How it Works",
    prizes: "Current NFT Prizes",
  },
  ecosystem: {
    navsTileGamers: "$TICO for Gamers",
    navsTilePublishers: "$TICO for Publishers",
    gamersMonetary: "MONETARY",
    gamersMonetaryItem1: "In-Game Purchases",
    gamersMonetaryItem2: "Access to Premium Content",
    gamersMonetaryItem3: "Monetization Opportunities",
    gamersPlatforms: "CROSS-PLATFORM",
    gamersPlatformsItem1: "Cross-Platform Interoperability",
    gamersUX: "USER EXPERIENCE",
    gamersUXItem1: "Enhanced Customization",
    gamersUXItem2: "Publisher as a Service",
    gamersUXItem3: "Item Ownership & Delegation",
    gamersMarketing: "ARTIFICIAL INTELLIGENCE",
    gamersMarketingItem1: "NFT Integration & Ownership",
    gamersMarketingItem2: "Rewards & Incentives for the Ecosystem",
    gamersMarketingItem3: "Micro Payments for AI Inference",
    gamersMarketingItem4: "AI Agents Utility Features (in development)",
    publishersMonetary: "MONETARY",
    publishersMonetaryItem1: "Convert any Web2.0 Game to Web3.0",
    publishersMonetaryItem2: "Increased Monetization Options",
    publishersMonetaryItem3: "Interconnected Token Ecosystem",
    publishersPublisherAsService: "PUBLISHER AS A SERVICE",
    publishersPublisherAsServiceItem1:
      "Complete Stack for Publishers Powered by $TICO",
    publishersUX: "USER EXPERIENCE",
    publishersUXItem1: "Enhanced Customization",
    publishersUXItem2: "Item Ownership",
    publishersMarketing: "MARKETING",
    publishersMarketingItem1: "Co-Branding and Cross-Promotions",
    publishersMarketingItem2:
      "Collaborative Incentive Programs & Publisher-Specific Discounts",
    publishersMarketingItem3: "Incentivised Loyalty",
    publishersMarketingItem4: "Community Engagement",
    bottomNotice:
      'As showcased above, <span class="fixel_14_sbl">Utility</span> is $TICO\'s nickname, offering the token multiple demand avenues and integrations.',
  },
  tico: {
    intro: {
      title: "Step Up Your Game With $TICO!",
      buyButton: "How To Buy $TICO",
      comingSoon: "Coming soon!",
    },
    whatIs: {
      title: "WHAT IS",
      description:
        "$TICO lies at the heart of every Funtico game, transaction, feature, and AI-driven system, uniting our entire platform under one dynamic ecosystem. Launched primarily as an ERC-20 token on Avalanche C-Chain and seamlessly bridged across Ethereum, Polygon, Base and other, $TICO delivers a flexible, cross-platform experience for gamers and developers alike. Designed with compliance in mind to address future challenges, $TICO stands as the foundation of Funtico's vision for next-generation Web3 AI & gaming infrastructure.",
      readLitepaper: "Read Our Litepaper",
    },
    audits: {
      title: "AUDITS",
      description:
        "The $TICO smart contract was audited by Sayfer, a leading auditing and cybersecurity company. Sayfer also conducted security audits to the Funtico Platform and its proprietary games, to ensure its, reliability, integrity, and compliance with industry standards.",
      tokenAudit: "Token Audit",
      bridgesAudit: "Bridges Audit",
      contractAddress: "CA:",
    },
    talks: {
      title: "Talks",
      subtitle: "Get into the conversation!",
    },
  },
  serverErrorCode: {
    terms_not_accepted_or_not_above_required_age:
      "Terms not accepted or not above required age",
    internal_server_error: "Internal server error",
    invalid_wallet_signature: "Invalid wallet signature",
    validation_failed: "Validation failed",
    user_removed_or_suspended: "User removed or suspended",
    user_not_found: "User not found",
    account_already_verified: "Account already verified",
    verify_link_already_send: "Verify link already send",
    please_complete_the_verification_check_your_email:
      "Please complete the verification check your email",
    account_is_not_locked: "Account is not locked",
    incorrect_token: "Incorrect token",
    invalid_or_expired_url: "Invalid or expired url",
    user_not_found_or_hash_expired: "User not found or hash expired",
    invalid_credentials: "Invalid credentials",
    disposable_email_not_allowed: "Disposable email not allowed",
    unable_to_register_user: "Unable to register user",
    wallet_already_connected_to_another_account:
      "This wallet address is already connected to another Funtico account.",
    discord_account_already_connected:
      "This Discord account is already connected to another Funtico account.",
    discord_account_connection_failed:
      "Your Discord account could not be connected. Please try again.",
    telegram_account_already_connected:
      "This Telegram account is already connected to another Funtico account.",
    telegram_account_connection_failed:
      "Your Telegram account could not be connected. Please try again.",
    wallet_connection_failed_general:
      "Your wallet could not be connected. Please try again.",
    email_required: "The email is required",
    email_invalid: "The email you try to set is invalid",
    email_unique:
      "The email you try to set is already taken by another Funtico user or the email is invalid",
    email_max:
      "The email must be at most 64 characters for your Funtico account",
    kyc_completed: "KYC is already completed.",
    email_already_set: "You cannot update your email for your Funtico account.",
    email_set_success: "Successfully set email",
    email_validation_error:
      "The email field should not contain emoticons or special characters.",
    email_max_64: "The email may not be greater than 64 characters",
  },
  popups: {
    buttonCheckReward: "Check Reward!",
    buttonClaimBonus: "Claim Daily Bonus!",
    privatePassReward: {
      title: "Rewards Received!",
      text: '<span class="color-primary">15 Private Passes</span> were added to your Backpack!',
    },
    sweatReward: {
      title: "Rewards Received!",
      text: '<span class="color-primary">3 Private Passes</span> were added to your Backpack!',
    },
    levelUp: {
      title: '<span class="color-primary">Leveled Up!</span>',
      text_1: "You have reached",
      rank_name: '<span class="color-primary fixel_16_bl">{{rank}}</span>',
      level:
        '<span class="fixel_16_bl" style="color: {{level_color}}">Level {{level}}</span>!',
      text_line_2:
        '<br /><span class="fixel_16_bl">Go to your Progress Page to check your reward(s)!',
    },
    rankUp: {
      title: '<span class="color-primary">New Rank Reached!</span>',
      text_1: "Congratulations! You have reached",
      rank_name: '<span class="color-primary fixel_16_bl">{{rank}}</span>',
      text_line_2:
        '<br /><span class="fixel_16_bl">Go to your Progress Page to check your reward(s)!</span>',
    },
    wofDailyBonusClaim: {
      title: 'Claim Your<br /><span class="color-primary">Daily Bonus!</span>',
      text: ' Claim your <span class="color-primary fixel_16_bl">Daily Bonus</span> and collect <span class="color-gold fixel_16_bl">Free<br />Wheel of Fortune Spins</span> and <span class="color-gold ">extra Experience Points</span>!',
    },
    wofDailyBonusAvailable: {
      title: '<span class="color-primary">Daily Bonus!</span><br />Available!',
      text: ' Claim your <span class="color-primary fixel_16_bl">Daily Bonus</span> and collect <span class="color-gold fixel_16_bl">Free<br />Wheel of Fortune Spins</span> and <span class="color-gold ">extra Experience Points</span>!',
      disclimer:
        "I know how to collect my Daily Bonus so don't show me this reminder anymore",
    },
    stopScrolling: {
      title:
        'Stop Scrolling!<br /><span class="color-primary">Start Earning!</span>',
      text: 'Grab your <span class="color-primary fixel_16_bl">Starter Bag</span> and open up multiple possibilities to <span class="color-gold fixel_16_bl">Compete-2-Win $TICO</span> Tokens!',
      buttonText: "Claim Starter Bag!",
    },
  },
  orientation: {
    rotateDevice: "Please rotate your device",
    betterExperience:
      "For a better gaming experience, please use landscape mode",
  },
  pwa: {
    addToHomescreenTitle: "Please add Funtico.com to your device home screen",
    addToHomescreenMessage: "Click share button and click Add to home screen",
  },
  form: {
    select_games: "Select games",
    nothing_found: "No results found",
    clear_selection: "Clear selection",
    game_selected_one: "{{count}} game selected",
    game_selected_other: "{{count}} games selected",
    search: "Search",
  },
};
